<div class="wrapper">

  @if (pageSizes(); as pageSizes) {

    <div [class.justify-content-between]="pageSizes?.length" [class.justify-content-center]="!pageSizes?.length"
         class="row">

      <div class="col-12 col-lg-auto mb-3 mb-lg-0">

        @if (pagesRange(); as pagesRange) {

          @if (pagesRange.length > 1) {

            <nav class="d-flex justify-content-center">

              <ul class="pagination pagination-sm d-inline-flex flex-row align-items-center">

                <li [class.disabled]="currentPage() === 1" class="page-prev page-item">

                  <a (click)="onPrevPageClick()" class="page-link d-inline-flex flex-row align-items-center">
                    <mat-icon class="icon" svgIcon="sax:outline-arrow-left-2"></mat-icon>
                    <span class="label d-none d-md-block" i18n>Попередня</span>
                  </a>

                </li>

                @for (page of pagesRange; track page) {

                  <li [class.inactive]="page === DOTS" [class.active]="page === currentPage()" class="page-number page-item">

                    @if (page === DOTS || page === currentPage()) {
                      <span class="page-link">{{page}}</span>
                    } @else {
                      <a (click)="onPageClick(page)" class="page-link">{{page}}</a>
                    }

                  </li>

                }

                <li [class.disabled]="currentPage() === pagesRange[pagesRange.length - 1]" class="page-next page-item">

                  <a (click)="onNextPageClick()" class="page-link d-inline-flex flex-row align-items-center">
                    <span class="label d-none d-md-block" i18n>Наступна</span>
                    <mat-icon class="icon" svgIcon="sax:outline-arrow-right-3"></mat-icon>
                  </a>

                </li>

              </ul>

            </nav>

          }

        }

      </div>

      @if (pageSizes.length) {

        <div class="col-12 col-lg-auto d-flex flex-row align-items-center justify-content-center justify-content-lg-end">

          <label for="pageSize" class="page-size-label form-label me-2" i18n>Результатів на сторінці:</label>

          <select [formControl]="pageSizeControl" id="pageSize" class="page-size-select form-select">

            @for (pageSize of pageSizes; track pageSize) {
              <option [value]="pageSize">{{pageSize}}</option>
            }

          </select>

        </div>

      }

    </div>

  }

</div>
